import { z } from 'zod';
export const ACCOUNT_KEY_GROUP_LABELS = {
    'cash-bank': 'เงินสด / ธนาคาร',
    ar: 'ลูกหนี้',
    ap: 'เจ้าหนี้',
    tax: 'ภาษี (VAT / หัก ณ ที่จ่าย / เงินได้)',
    revenue: 'รายได้ / ต้นทุนขาย',
    expense: 'ค่าใช้จ่าย',
    asset: 'สินทรัพย์อื่น',
    equity: 'ส่วนของผู้ถือหุ้น',
    'emp-benefit': 'ผลประโยชน์พนักงาน (TAS 19)',
    'property-tax': 'ภาษีที่ดิน & ป้าย',
    cip: 'งานระหว่างก่อสร้าง (CIP)',
    'fixed-asset': 'สินทรัพย์ถาวร (ค่าเริ่มต้น)',
    lease: 'สัญญาเช่า TFRS 16 (ค่าเริ่มต้น)',
};
// One entry per ACCOUNT_KEYS member (Thai label + group). Keep in sync with
// account-keys.ts (a compile-time check below asserts full coverage).
export const ACCOUNT_KEY_META = {
    CASH_PETTY: { group: 'cash-bank', label: 'เงินสดย่อย' },
    CASH_ON_HAND: { group: 'cash-bank', label: 'เงินสดในมือ' },
    CASH_OVER_SHORT: { group: 'cash-bank', label: 'เงินขาด/เกินบัญชี' },
    BANK_PRIMARY: { group: 'cash-bank', label: 'เงินฝากธนาคารหลัก (default cash)' },
    BANK_FEE: { group: 'cash-bank', label: 'ค่าธรรมเนียมธนาคาร' },
    AR_TRADE: { group: 'ar', label: 'ลูกหนี้การค้าในประเทศ' },
    AR_FOREIGN: { group: 'ar', label: 'ลูกหนี้การค้าต่างประเทศ' },
    CUSTOMER_ADVANCE: { group: 'ar', label: 'รายได้รับล่วงหน้า (เงินรับล่วงหน้าลูกค้า)' },
    AP_TRADE: { group: 'ap', label: 'เจ้าหนี้การค้าในประเทศ' },
    AP_FOREIGN: { group: 'ap', label: 'เจ้าหนี้การค้าต่างประเทศ' },
    RETENTION_PAYABLE: { group: 'ap', label: 'เจ้าหนี้-เงินประกันผลงาน' },
    VAT_OUTPUT: { group: 'tax', label: 'ภาษีขาย (Output VAT)' },
    VAT_INPUT: { group: 'tax', label: 'ภาษีซื้อ (Input VAT)' },
    VAT_INPUT_SUSPENSE: { group: 'tax', label: 'ภาษีซื้อค้างรับ (ยังไม่ถึงกำหนด)' },
    VAT_INPUT_PROHIBITED: { group: 'tax', label: 'ภาษีซื้อต้องห้าม' },
    VAT_INPUT_EXPIRED: { group: 'tax', label: 'ภาษีซื้อเกินกำหนด (ตัดจำหน่าย)' },
    WHT_PAYABLE: { group: 'tax', label: 'ภาษีหัก ณ ที่จ่าย ค้างนำส่ง' },
    WHT_PREPAID: { group: 'tax', label: 'ภาษีถูกหัก ณ ที่จ่าย (สินทรัพย์)' },
    INCOME_TAX_PAYABLE: { group: 'tax', label: 'ภาษีเงินได้นิติบุคคลค้างจ่าย' },
    DEFERRED_TAX_EXPENSE: { group: 'tax', label: 'ค่าใช้จ่ายภาษีเงินได้รอตัดบัญชี' },
    SALES_DOMESTIC: { group: 'revenue', label: 'รายได้ขายในประเทศ (default revenue)' },
    SALES_EXPORT: { group: 'revenue', label: 'รายได้ขายส่งออก' },
    COGS: { group: 'revenue', label: 'ต้นทุนขาย' },
    INTEREST_INCOME: { group: 'revenue', label: 'ดอกเบี้ยรับ' },
    DISCOUNT_RECEIVED: { group: 'revenue', label: 'ส่วนลดรับ (จ่ายเร็ว)' },
    ACCRUED_EXPENSE: { group: 'expense', label: 'ค่าใช้จ่ายค้างจ่าย' },
    INTEREST_EXPENSE: { group: 'expense', label: 'ดอกเบี้ยจ่าย' },
    MISC_EXPENSE: { group: 'expense', label: 'ค่าใช้จ่ายเบ็ดเตล็ด' },
    LVA_EXPENSE: { group: 'expense', label: 'ค่าใช้จ่ายทรัพย์สินมูลค่าน้อย (LVA)' },
    FX_GAIN_LOSS: { group: 'expense', label: 'กำไร/ขาดทุนจากอัตราแลกเปลี่ยน' },
    GAIN_LOSS_DISPOSAL: { group: 'expense', label: 'กำไร/ขาดทุนจากการขายสินทรัพย์' },
    PREPAID_ASSET: { group: 'asset', label: 'ค่าใช้จ่ายจ่ายล่วงหน้า' },
    EMPLOYEE_ADVANCE: { group: 'asset', label: 'เงินทดรองจ่ายพนักงาน' },
    RETAINED_EARNINGS: { group: 'equity', label: 'กำไรสะสม' },
    EMP_BENEFIT_EXPENSE: { group: 'emp-benefit', label: 'ค่าใช้จ่ายผลประโยชน์พนักงาน' },
    EMP_BENEFIT_LIABILITY: { group: 'emp-benefit', label: 'ประมาณการหนี้สินผลประโยชน์พนักงาน' },
    EMP_BENEFIT_REMEASUREMENT_OCI: {
        group: 'emp-benefit',
        label: 'กำไร/ขาดทุนจากการประมาณการ (OCI)',
    },
    EMP_BENEFIT_SETTLEMENT_GAINLOSS: {
        group: 'emp-benefit',
        label: 'กำไร/ขาดทุนจากการจ่ายผลประโยชน์',
    },
    PROPERTY_TAX_LAND_EXPENSE: {
        group: 'property-tax',
        label: 'ค่าใช้จ่ายภาษีที่ดินและสิ่งปลูกสร้าง',
    },
    PROPERTY_TAX_SIGN_EXPENSE: { group: 'property-tax', label: 'ค่าใช้จ่ายภาษีป้าย' },
    PROPERTY_TAX_LAND_ACCRUED: { group: 'property-tax', label: 'ภาษีที่ดินค้างจ่าย' },
    PROPERTY_TAX_SIGN_ACCRUED: { group: 'property-tax', label: 'ภาษีป้ายค้างจ่าย' },
    CIP_ASSET: { group: 'cip', label: 'งานระหว่างก่อสร้าง' },
    CIP_CLEARING: { group: 'cip', label: 'พักรับงานระหว่างก่อสร้าง' },
    FA_COST: { group: 'fixed-asset', label: 'สินทรัพย์ถาวร — ราคาทุน (ค่าเริ่มต้น)' },
    FA_CLEARING: { group: 'fixed-asset', label: 'พักรับทรัพย์สิน' },
    FA_ACCUM_DEP: { group: 'fixed-asset', label: 'ค่าเสื่อมราคาสะสม (ค่าเริ่มต้น)' },
    FA_DEP_EXPENSE: { group: 'fixed-asset', label: 'ค่าเสื่อมราคา (ค่าเริ่มต้น)' },
    FA_DISPOSAL_GAIN_LOSS: { group: 'fixed-asset', label: 'กำไร/ขาดทุนจากการขายสินทรัพย์' },
    LEASE_ROU_ASSET: { group: 'lease', label: 'สิทธิการใช้สินทรัพย์ (ROU)' },
    LEASE_ACCUM_DEP: { group: 'lease', label: 'ค่าเสื่อมสะสม ROU' },
    LEASE_LIABILITY: { group: 'lease', label: 'หนี้สินตามสัญญาเช่า' },
    LEASE_INTEREST: { group: 'lease', label: 'ดอกเบี้ยจ่ายตามสัญญาเช่า' },
    LEASE_DEP_EXPENSE: { group: 'lease', label: 'ค่าเสื่อมราคา ROU' },
    LEASE_TERM_GAIN_LOSS: { group: 'lease', label: 'กำไร/ขาดทุนจากการเลิกสัญญาเช่า' },
};
// Group display order for the settings page.
export const ACCOUNT_KEY_GROUP_ORDER = [
    'cash-bank',
    'ar',
    'ap',
    'tax',
    'revenue',
    'expense',
    'asset',
    'equity',
    'emp-benefit',
    'property-tax',
    'cip',
    'fixed-asset',
    'lease',
];
export const UpdateAccountMappingSchema = z.object({
    accountCode: z.string().trim().min(2).max(20),
    note: z.string().trim().max(200).optional(),
});
//# sourceMappingURL=account-mapping.js.map